import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CookieService } from 'ngx-cookie';

@Component({
    selector: 'mlp-ng-footer-nav',
    templateUrl: './footer.nav.component.html',
    styleUrls: ['./footer.nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class FooterNavSharedComponent {
    @Input() title: string;
    @Input() data: any;

    constructor(public cookieService: CookieService) {}

    clearCityCookie(url: string): void {
        if (url === '/') {
            this.cookieService.remove('city');
            window.location.href = '/';
        }
    }
}
